export default function parseErrorExplanation(postResponseText) {
  const domparser = new DOMParser()
  const postDoc = domparser.parseFromString(postResponseText, 'text/html')
  const errorExplanationElem =
    postDoc.getElementById('errorExplanation') ||
    postDoc.getElementById("'errorExplanation'")
  return errorExplanationElem
}
